import BaseChart from './BaseChart';

/**
 * Map chart implementation using VChart
 */
class MapChart extends BaseChart {
  /**
   * Get chart specification for map chart
   * @returns {Object} Chart specification
   */
  getChartSpecification() {
    const commonConfig = this.getCommonConfig();
    const data = this.prepareData();
    
    // Map specific fields — auto-detect from data when defaults don't match
    const nameField = this._resolveField(
      'nameField', 'name', ['region', 'country', 'area', 'label', 'location', 'state', 'province']
    ) || this._resolveNameField();
    const valueField = this._resolveField(
      'valueField', 'value', ['count', 'amount', 'total', 'score', 'quantity']
    ) || this._resolveValueField();

    if (!this.options.geoData) {
      console.warn('[MapChart] geoData option is required for map rendering. Chart may appear empty.');
    }

    return {
      type: 'map',
      data,
      nameField,
      valueField,
      geoData: this.options.geoData,
      
      // Color configuration for choropleth
      color: {
        type: 'linear',
        domain: this.getValueDomain(),
        range: this.options.colorRange || ['#eff3ff', '#2171b5'],
        ...this.options.colorScale
      },
      
      // Map specific styling
      map: {
        style: {
          stroke: '#fff',
          lineWidth: 1,
          ...this.options.mapStyle
        },
        state: {
          hover: {
            stroke: '#fff',
            lineWidth: 2
          },
          ...this.options.mapState
        }
      },
      
      // Label configuration
      label: {
        visible: this.options.showLabels === true,
        style: {
          fontSize: 10,
          fontWeight: 'normal',
          ...this.options.labelStyle
        },
        formatter: this.options.labelFormatter
      },
      
      // Zoom and pan control
      zoom: {
        enabled: this.options.enableZoom !== false,
        ...this.options.zoom
      },
      
      // Animation configuration
      animationAppear: {
        duration: 800,
        easing: 'cubicOut',
        ...this.options.animationAppear
      },
      
      // Common configuration from BaseChart
      ...commonConfig
    };
  }
  
  /**
   * Get value domain for color scaling
   * @returns {Array} Value domain [min, max]
   */
  getValueDomain() {
    if (!this.data || this.data.length === 0) {
      return [0, 1];
    }

    const valueField = this._resolveField('valueField', 'value', ['count', 'amount', 'total', 'score', 'quantity'])
      || this._resolveValueField();
    let min = Infinity;
    let max = -Infinity;
    
    this.data.forEach(item => {
      if (item[valueField] < min) min = item[valueField];
      if (item[valueField] > max) max = item[valueField];
    });
    
    return [min, max];
  }
}

export default MapChart; 